import { Api } from '@/services/Api'

export default {
  updateUserDetails(payload) {
    return Api().put('/api/v2/user', payload)
  }
}
